export const currencyMixin = {

    computed: {

        accountingCurrency() {
            return this.$store.state.PanelSettings.settings.accounting_currency;
        },

        accountingCurrencyToRewardPoints() {
            return this.$store.state.PanelSettings.settings.currency_unit_to_points;
        },

        accountingCurrencyDefined() {
            return this.$store.state.PanelSettings.settings.accounting_currency !== null;
        },

        accountingCurrencyOther() {
            return !this.accountingCurrencyPrefixIcon && !this.accountingCurrencyPostfixIcon;
        },

        accountingCurrencyPrefix() {
            if (!this.accountingCurrencyDefined) return null;
            return this.getCurrencyPrefix(this.accountingCurrency);
        },

        accountingCurrencyPostfix() {
            if (!this.accountingCurrencyDefined) return null;
            return this.getCurrencyPostfix(this.accountingCurrency);
        },

        accountingCurrencyPrefixIcon() {
            if (!this.accountingCurrencyDefined) return 'mdi-currency-sign';
            return this.getCurrencyPrefixIcon(this.accountingCurrency);
        },

        accountingCurrencyPostfixIcon() {
            return this.getCurrencyPostfixIcon(this.accountingCurrency);
        },
    },

    methods: {

        getCurrencyPrefixIcon(currency) {
            if (['USD', 'CAD', 'AUD'].includes(currency)) {
                return 'mdi-currency-usd';
            }

            if (currency === 'GBP') {
                return 'mdi-currency-gbp';
            }

            return null;
        },

        getCurrencyPostfixIcon(currency) {
            if (currency === 'EUR') return 'mdi-currency-eur';
            return null;
        },

        getCurrencyPrefix(currency) {
            if (['USD', 'CAD', 'AUD'].includes(currency)) return '$';
            if (currency === 'GBP') return '£';
            return null;
        },

        getCurrencyPostfix(currency) {
            if (currency === 'EUR') return '€';
            return null;
        },

        convertToAccountingCurrency(amount, toLocaleString = false) {

            let converted = null;

            if (this.accountingCurrencyDefined) {
                converted = Math.round(amount / this.accountingCurrencyToRewardPoints * 100) / 100;
            } else {
                converted = amount;
            }

            if (toLocaleString) {
                return converted.toLocaleString(undefined, {minimumFractionDigits: 2});
            }

            return converted;
        },
    }
};

